/* Publish by EComposer at 2026-10-15 13:12:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-phw7kbfymw"]=  window.__ectimmers["ecom-phw7kbfymw"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-phw7kbfymw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phw7kbfymw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oxtgy0liehi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oxtgy0liehi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1aq8zfv7s1n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1aq8zfv7s1n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uao31qw3vhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uao31qw3vhi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7d08sxjzjd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7d08sxjzjd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2n5eqeyk7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2n5eqeyk7b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-th3167zdpuc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-th3167zdpuc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sd2ce4hj13').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sd2ce4hj13', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4prqrvw9tdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4prqrvw9tdd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s1zfsuynnvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1zfsuynnvf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8uit4gjrppr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8uit4gjrppr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7beoqxg2v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7beoqxg2v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x7idmrf5cdr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x7idmrf5cdr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tr1oor127vg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tr1oor127vg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2mdnvgbhw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2mdnvgbhw8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wug6p364uj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wug6p364uj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4wz4susewd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4wz4susewd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mf5c2f685q9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mf5c2f685q9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ojvahat8ltk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ojvahat8ltk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9de7hbkux8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9de7hbkux8f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urwrfhxk7dc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urwrfhxk7dc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ayj8ovu9d2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ayj8ovu9d2o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5tn4co7focr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5tn4co7focr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll05df46xdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll05df46xdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u5qah4n4v8d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u5qah4n4v8d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2fr1fmnbvie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2fr1fmnbvie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-141iafsuolgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-141iafsuolgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hge0f0qhwiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hge0f0qhwiq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwajq6rl33p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwajq6rl33p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypi5e3tju7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypi5e3tju7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uk3jetw0bje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uk3jetw0bje', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yjdg845es').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yjdg845es', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w1wei6m474').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w1wei6m474', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wgjmuweqv8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wgjmuweqv8i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnbppwoyelf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnbppwoyelf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zde9irsaw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zde9irsaw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdtvrdjm8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdtvrdjm8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ud6y9ano0y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ud6y9ano0y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i3yf11qtxu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i3yf11qtxu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5h0weakgp7t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5h0weakgp7t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c6xu9b3vors').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c6xu9b3vors', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpk0kue3t1t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpk0kue3t1t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z449b998nn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z449b998nn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27z7onp83mh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27z7onp83mh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-73w1242qlxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-73w1242qlxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gyawowuuo9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gyawowuuo9p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oryp8k3fes8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oryp8k3fes8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rywixgoh8d8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rywixgoh8d8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ngo1glty8g8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ngo1glty8g8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wysy0b8tsyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wysy0b8tsyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xh52x4q9rfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xh52x4q9rfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8nlh2ey5i2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8nlh2ey5i2o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ylr2nkgavc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ylr2nkgavc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sx2uadt54v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sx2uadt54v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q6wwdjuntfi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6wwdjuntfi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dx0ubvbqs7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dx0ubvbqs7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3pj4ce1vng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3pj4ce1vng', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-72uoj5d6k1u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72uoj5d6k1u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2602hkn8hib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2602hkn8hib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zyykdfxm8gg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zyykdfxm8gg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9rthv0xnmbv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9rthv0xnmbv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gsnyup03okt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gsnyup03okt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zn8esc0llf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zn8esc0llf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qprfi6kvpuf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qprfi6kvpuf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q756ve9cjm8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q756ve9cjm8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pyx2baax5jg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pyx2baax5jg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46fjfr6jxdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46fjfr6jxdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wnlbxloc6fi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wnlbxloc6fi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-si3bt0p0roi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-si3bt0p0roi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j6vu8l87a18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j6vu8l87a18', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkmzlw8ngv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkmzlw8ngv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98px053atlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98px053atlr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wsc2mqa7nw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wsc2mqa7nw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z0bhrjnnlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z0bhrjnnlc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gdcmpkgssl5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gdcmpkgssl5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-unv8lclj3mp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unv8lclj3mp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emjdd0oc2jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emjdd0oc2jp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8o0x3l3fwz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8o0x3l3fwz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxg2ggmloll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxg2ggmloll', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-icfmgjuen8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icfmgjuen8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20o1zy178bf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20o1zy178bf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vne2fpxx3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vne2fpxx3g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1yfxbda0rem').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1yfxbda0rem', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-deigtrvvooi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-deigtrvvooi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jyhi2iwzo3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jyhi2iwzo3i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3olv0w4xzka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3olv0w4xzka', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-21oors78e74').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-21oors78e74', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g3tlqf78gzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g3tlqf78gzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4p3hof1x1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4p3hof1x1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iiuvzslu8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iiuvzslu8t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99ogyqacf9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99ogyqacf9l', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3kriidsetrw"]=  window.__ectimmers["ecom-3kriidsetrw"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-3kriidsetrw"]["ohhu7yd8t"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-3kriidsetrw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kriidsetrw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7u738yasznd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7u738yasznd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xcq7tgrkba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xcq7tgrkba', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9tm230tvae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9tm230tvae', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8x90r17mnh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8x90r17mnh9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m00p6dedbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m00p6dedbd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i40s4kbbdf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i40s4kbbdf8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bf613zsy0vr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bf613zsy0vr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drfoj8l6x75').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drfoj8l6x75', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mwvvfl2wgza').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mwvvfl2wgza', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ggiw2vc9t9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ggiw2vc9t9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32radd9bztv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32radd9bztv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gnvhdj865tf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gnvhdj865tf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-als0r65tzpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-als0r65tzpi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z0ngzbv72b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z0ngzbv72b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wexs33ttmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wexs33ttmf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mv4w0sl987d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mv4w0sl987d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyb6yckeuh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyb6yckeuh6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7nv2zlbm55g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nv2zlbm55g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-da7qas2ool4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-da7qas2ool4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9cxj2qn8urr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9cxj2qn8urr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xepyjnskuaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xepyjnskuaa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilowafa9rc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilowafa9rc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzxwv9xmbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzxwv9xmbr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cez0108f73k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cez0108f73k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ty5tbj62h5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ty5tbj62h5', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jzbspz5evg"]=  window.__ectimmers["ecom-jzbspz5evg"] || {};
var $,E,A,j,P,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,s=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,n=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(P=this.settings.disable_effect)!=null?P:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(I=>I.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(I){const D=I.getBoundingClientRect();return D.top>=0&&D.left>=0&&D.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&D.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(I){return o&&I<768||s&&I>767&&I<1025||i&&I>1024}function b(I){if(!I)return;const D=I.style.transition;I.style.transition="none",I.style.height="auto";const R=I.scrollHeight;I.style.height="0px",I.offsetHeight,I.style.transition=D,requestAnimationFrame(()=>{const H=r?"auto":e?R+"px":"auto";I.style.height=H})}function y(I){I.classList.remove("ecom-item-active");const D=I.querySelector(":scope > .ecom-accordion__body");D&&(r||(D.style.height=D.scrollHeight+"px",D.offsetHeight),requestAnimationFrame(()=>{D.style.height="0px"}))}function v(I){let D=0;if(I.offsetParent)do D+=I.offsetTop;while(I=I.offsetParent);return D}function w(I){const D=Math.max(0,I),R=window.pageYOffset||document.documentElement.scrollTop,H=D-R;if(H===0)return;const K=300;let V=null;function G(te){V||(V=te);const ne=Math.min((te-V)/K,1),Y=ne<.5?2*ne*ne:1-Math.pow(-2*ne+2,2)/2;window.scrollTo(0,R+H*Y),ne<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function z(I){w(v(I)-100)}function C(I,D=!1){I.forEach((R,H)=>{const K=R.parentNode,V=K.querySelector(":scope > .ecom-accordion__body");!r&&V&&V.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");V&&!a&&(D&&H===0||G)&&requestAnimationFrame(()=>{V.style.height=V.scrollHeight+"px"}),R.onclick=function(te){var pe,_e;if(te.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const ne=m(),Y=this.parentNode,he=Y.parentNode,ce=he.querySelectorAll(":scope > .ecom-accordion__item"),ue=Array.from(ce).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),X=_(ne);if(U)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ce.forEach(y),ue.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(ce.forEach(y),ue.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),R.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(pe=we.parentElement)==null?void 0:pe.closest)==null?void 0:_e.call(pe,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const ee=this,ge=n||ne>1024;function Q(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(ee)&&z(ee)}if(ge&&!r){let we;const Ae=function(Te){Te.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},50))};he.addEventListener("transitionend",Ae),setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},600)}else requestAnimationFrame(()=>{setTimeout(Q,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const I=t.querySelector(".ecom-item-group-init");I&&I.classList.remove("ecom-item-group-init")});function S(){const I=window.location.hash;if(I){const D=t.querySelector(`[data-target="${I}"]`);if(D){D.click(),D.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=D.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(S,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",S,!1)

                    });
                    
                        document.querySelectorAll('.ecom-jzbspz5evg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jzbspz5evg', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pvbio4mg4vc"]=  window.__ectimmers["ecom-pvbio4mg4vc"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-pvbio4mg4vc"]["nsc9e43fl"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-pvbio4mg4vc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvbio4mg4vc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l135wxx1tml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l135wxx1tml', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1huslsbrlhr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1huslsbrlhr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sry45wv8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sry45wv8i', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hdsw9j4qm4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hdsw9j4qm4t', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2iphv7930f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2iphv7930f', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lniuklqaum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lniuklqaum', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wpj7opjzrni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wpj7opjzrni', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7kxat9eazi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7kxat9eazi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xim388y6ix').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xim388y6ix', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4171j1h4vw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4171j1h4vw8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-socmzm9p59q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-socmzm9p59q', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4ouxjojgcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4ouxjojgcm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zkq42hj859j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zkq42hj859j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}